import type { CartSecretCodes } from '~/types';
import { type InjectionKey } from 'vue';
import { CouponCodeSecrets } from '~/constants';

export const CartSecretCodesKey: InjectionKey<CartSecretCodes> = Symbol.for('CartSecretCodes');

const populatedSecretCodes: CartSecretCodes = new Map();
CouponCodeSecrets.map((code) => populatedSecretCodes.set(code, null));

export const cartSecretCodes = reactive<CartSecretCodes>(populatedSecretCodes);

cartSecretCodes.clear = function(): void {
    this.forEach((_, key) => this.set(key, null));
};

export function useCartSecretCodes() {
    const createCartSecretCodes = inject<CartSecretCodes>(CartSecretCodesKey);

    if (!createCartSecretCodes) {
        throw new Error('Could not resolve Cart Secret Code provider');
    }

    return {
        cartSecretCodes: createCartSecretCodes,
        clear: createCartSecretCodes.clear
    };
}
